export default __webpack_public_path__ + "static/media/Prancheta 6.e55f1f95.svg";